var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_12128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2360_12128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H0V29H29V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2360_12128)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2360_12128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H0V29H29V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2360_12128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28.5C22.232 28.5 28.5 22.232 28.5 14.5C28.5 6.76801 22.232 0.5 14.5 0.5C6.76801 0.5 0.5 6.76801 0.5 14.5C0.5 22.232 6.76801 28.5 14.5 28.5Z",
    stroke: "#F26D00",
    strokeLinecap: "round"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6236 23.2831L8.03329 16.5118L7.76734 16.2385C6.95155 15.3839 6.49467 14.2303 6.50005 13.0276C6.50543 11.8243 6.97319 10.6744 7.79747 9.82743C8.62132 8.98095 9.73426 8.50552 10.8934 8.50005C12.0518 8.49458 13.1682 8.95889 13.9993 9.79648L14.2653 10.0697L14.6231 10.4374L14.9814 10.0702L15.2467 9.79836C16.079 8.96772 17.193 8.50914 18.3475 8.51732C19.503 8.5255 20.6118 9.00065 21.4331 9.84447C22.2549 10.6887 22.7225 11.8342 22.7307 13.0339C22.7388 14.2323 22.2878 15.3835 21.479 16.2394L21.2138 16.5118L14.6236 23.2831Z",
    stroke: "#F26D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_12128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFav);
export default __webpack_public_path__ + "static/media/fav.34fa9149ab7475f389c64fb12b9d5af4.svg";
export { ForwardRef as ReactComponent };